import Vue from "vue";
import Router from "vue-router";

Vue.use(Router)

export default new Router({
    routes: [
        {
            path:'/',
            redirect: '/login'
        },
        {
            path: '/',
            component: resolve => require(['../components/nav/framework.vue'], resolve),
            children: [
                {
                    path: '/home',
                    component: resolve => require(['../components/pages/home.vue'], resolve),
                },
                {
                    path: '/login',
                    component: resolve => require(['../components/pages/Login.vue'], resolve),
                },
               
            ]
        },
        {
            path: '/login',
            component: resolve => require(['../components/pages/Login.vue'], resolve),
        },
    ]
})